<template>
  <div class="view-achievements">
    <h1 class="page-title">
      Conquistas
      <small>Aqui você encontra as conquistas que adquirir na Blitzpay</small>
    </h1>

    <action-dispatcher action="user/getAchievements">
      <div class="mt-6" v-for="it in achievements" :key="it.id">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex">
            <div class="mr-3">
              <img
                :src="it.picture"
                class="img-badge"
                :class="{ disabled: it.points_left > 0 }"
              />
            </div>
            <div class="d-flex flex-column">
              <div class="d-flex">
                <h5 class="mb-0 mr-3">{{ it.name }}</h5>
                <small class="text-dark" v-if="it.points_left > 0">
                  {{ `Faltam ${it.points_left} pontos` }}
                </small>
                <small v-else class="text-success">
                  Concluído <i class="icon-check"></i>
                </small>
              </div>
              <small class="text-secondary">{{ it.description }}</small>
            </div>
          </div>

          <div>
            <form-group
              isSwitch
              :id="`visible-${it.id}`"
              v-model="it.visible"
              label="Visível"
            />
          </div>
        </div>
        <hr />
      </div>
    </action-dispatcher>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("user", ["achievements"])
  }
};
</script>
<style lang="scss" scoped>
.view-achievements {
  .img-badge {
    width: 50px;
    height: 50px;

    &.disabled {
      opacity: 0.5;
      filter: grayscale(60%);
    }
  }

  .icon-check {
    background-color: #04c56b;
    color: #fff;
    border-radius: 25px;
    padding: 2px;
  }

  ::v-deep label {
    padding-top: 5px;
    padding-left: 10px;
  }

  small {
    font-size: 12px;
  }
  .text-success {
    min-width: 79px;
    font-size: 11px;
  }
}
</style>
